import React, { useState } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeCategoryElement from './TreeCategoryElement';
import TreeProductElement from './TreeProductElement';
import Repositions from './Repositions';
import ReactModal from '../../../../../components/ReactModal';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ManageCategory from '../../../../../components/ManageCategory';
import ManageProduct from '../../../../../components/ManageProduct';

const TreeCategory = (props) => {
  const { category, expanded, setExpanded, style } = props;
  const [repositionsModalIsOpen, setRepositionsModalIsOpen] = useState(false);
  const [editCategoryModalIsOpen, setEditCategoryModalIsOpen] = useState(false);
  const [newProductModalIsOpen, setNewProductModalIsOpen] = useState(false);

  // const isSubCategory = category.nested && category.nested.length > 0;

  const handleRepositions = (e) => {
    e.stopPropagation();
    setRepositionsModalIsOpen(true);
  };

  const handleEditCategory = (e) => {
    e.stopPropagation();
    setEditCategoryModalIsOpen(true);
  };

  const handleAddProduct = (e) => {
    e.stopPropagation();
    setNewProductModalIsOpen(true);
  };

  const smallWindow = window.innerWidth < 500;

  return (
    <div style={{ position: 'relative', marginLeft: '-20px', marginRight: '10px', ...style }}>
      <TreeItem
        key={category.id}
        nodeId={category.id}
        label={<TreeCategoryElement category={category} />}
        style={{ margin: '16px 0' }}
        onClick={() => {
          const newExpanded = { ...expanded };
          newExpanded[category.id] = !expanded[category.id];
          setExpanded(newExpanded);
        }}
      >
        {category.products &&
          category.products.map((product) => {
            const nodeId = `${product.id}-${category.id}`;
            return (
              <TreeItem
                key={product.id}
                nodeId={nodeId}
                label={<TreeProductElement product={product} fromCategoryId={category.id} />}
                style={{ margin: '8px 0px 8px 8px' }}
              />
            );
          })}
      </TreeItem>
      {expanded[category.id] && (
        <div
          style={{
            position: 'absolute',
            top: smallWindow ? -16 : 16,
            right: smallWindow ? -16 : 16,
          }}
        >
          <FormatListNumberedIcon
            className="s-24-i txt-info pl-16 pr-8"
            onClick={handleRepositions}
          />
          <EditIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleEditCategory} />
          <AddCircleIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleAddProduct} />
        </div>
      )}
      {repositionsModalIsOpen && (
        <ReactModal modalIsOpen={repositionsModalIsOpen} setIsOpen={setRepositionsModalIsOpen}>
          <Repositions
            reposition={{
              type: 'products',
              filter: category.id,
            }}
            close={() => {
              setRepositionsModalIsOpen(false);
              const newExpanded = { ...expanded };
              newExpanded[category.id] = true;
              setExpanded(newExpanded);
            }}
          />
        </ReactModal>
      )}
      {editCategoryModalIsOpen && (
        <ReactModal modalIsOpen={editCategoryModalIsOpen} setIsOpen={setEditCategoryModalIsOpen}>
          <ManageCategory
            categoryId={category.id}
            serviceId={category.service_id}
            close={() => setEditCategoryModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
      {newProductModalIsOpen && (
        <ReactModal modalIsOpen={newProductModalIsOpen} setIsOpen={setNewProductModalIsOpen}>
          <ManageProduct
            productId="new"
            categoryId={category.id}
            close={() => setNewProductModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeCategory;
